export const queries = {
    namespaced: true,
    state: {
        selectedServer: null,
        selectedDB: null,
        query: '',
    },
    mutations: {
        UDPATE_SELECTED_SERVER(state, val) {
            state.selectedServer = val;
        },
        UDPATE_SELECTED_DB(state, val) {
            state.selectedDB = val;
        },
        UPDATE_QUERY(state, val) {
            state.query = val;
        }
    },
    actions: {
        updateSelectedServer({commit}, val) {
            commit('UDPATE_SELECTED_SERVER', val);
        },
        updateSelectedDB({commit}, val) {
            commit('UDPATE_SELECTED_DB', val);
        },
        updateQuery({commit}, val) {
            commit('UPDATE_QUERY', val);
        }
    },
    getters: {
        selectedServer: state => state.selectedServer,
        selectedDB: state => state.selectedDB,
        query: state => state.query
    }
};
